import React from "react";
import searchIcon from "../../assets/svgs/search.svg";
import AiCard from "../../components/AiCard";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import { getPrevChats } from "../../service/prevChats";
import { formatDateToDayMonth, formatTimeToHourMinute } from "../../utils/date";
import { isValidArray } from "../../utils/modules";

const AllBots = () => {
  const [searchString, setSearchString] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);

  React.useEffect(() => {
    const prevChats = getPrevChats();
    const orderedChats = prevChats.sort(
      (a, b) => new Date(b.time) - new Date(a.time)
    );
    setFilteredData(orderedChats);
  }, []);

  React.useEffect(() => {
    if (searchString === "") {
      setFilteredData(
        getPrevChats().sort((a, b) => new Date(b.time) - new Date(a.time))
      );
    } else {
      const filtered = getPrevChats()
        .reverse()
        .filter((card) =>
          card.title.toLowerCase().includes(searchString.toLowerCase())
        );
      setFilteredData(filtered);
    }
  }, [searchString]);

  const handleSearch = (e) => {
    setSearchString(e.target.value);
  };

  const showDate = (time) => {
    const lastChatDate = new Date(time);
    if (formatDateToDayMonth(lastChatDate) === formatDateToDayMonth()) {
      return formatTimeToHourMinute(lastChatDate);
    } else {
      return formatDateToDayMonth(lastChatDate);
    }
  };

  return (
    <MobileViewLayout>
      <div>
        <h2
          style={{ fontWeight: 700, fontSize: "24px" }}
          className="m-0 text-center py-4"
        >
          All Chats
        </h2>
        <div
          style={{
            backgroundColor: "#F6F7F9",
            padding: "7px",
            paddingLeft: "37px",
            border: "1px solid #D6D6D6",
            borderRadius: "5px",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            alt="Search"
            src={searchIcon}
            style={{ height: "25px", position: "absolute", left: "7px" }}
          />
          <input
            onChange={handleSearch}
            className="allbots-search-box"
            placeholder="Search chats"
          />
        </div>
        {isValidArray(filteredData) ? (
          <div
            style={{
              paddingTop: "15px",
              marginBottom: "70px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {filteredData?.map((card) => (
              <AiCard
                name={card.name}
                conversation={card.conversation}
                time={showDate(card.time)}
                chatId={card.id}
                key={card.id}
                image={card?.image}
                title={card?.title}
                desc={card?.desc}
              />
            ))}
          </div>
        ) : (
          <p className="mt-3 text-center" style={{ color: "#989898" }}>
            No chats available
          </p>
        )}
      </div>
    </MobileViewLayout>
  );
};

export default AllBots;
